import axios, { AxiosRequestConfig } from 'axios';
// config
import { HOST_API } from 'src/config-global';
import creds from "../api/creds";

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API, withCredentials: true });

axiosInstance.interceptors.response.use(
  (res) => {
    if(res.data?.status === 401) {
      window.location.href = '/';
      creds.resetCookie();
    }
    if(res.data?.status === 426) {
      window.location.href = '/update';
      creds.resetCookie();
    }
    return res;
  },
  (error) => {
    console.error(error);
    console.error(JSON.stringify(error));
    return Promise.reject((error.response && error.response.data) || 'Нещо се обърка. Опитайте по-късно')
  }
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  // eslint-disable-next-line prefer-const
  let [url, config] = Array.isArray(args) ? args : [args];

  if(!config) {
    config = {};
  }
  if(!config.headers) {
    config.headers = {
      'x-session-id': await creds.data.getCookie(),
    };
  }

  config.headers['x-session-id'] = await creds.data.getCookie();

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },



  problems: {
    list: '/problem',
  },
  auth: {
    me: '/auth/me',
    login: '/auth/login',
    register: '/auth/register',
    registerGuest: '/auth/register/guest',
    logout: '/auth/logout',
  },
};
